<template>
    <div>
        <div class="title">
            <h3>客户基本信息 <span style="font-size:12px;color:red;font-weight:400">修改客户信息时记得保存哦</span></h3>
            <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
        </div>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
            <Row>
                <Col span="12">
                    <FormItem label="姓名" prop="member.name">
                        <Input v-model="formValidate.member.name" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="身份证">
                        <Input v-model="formValidate.member.id_card" placeholder="请输入" @on-blur="idCardBlur(formValidate.member.id_card)"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="出生日期" >
                        <DatePicker type="date" placeholder="请选择" style="display:block" v-model="formValidate.member.birthday"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机" prop="member.phone">
                        <Input v-model="formValidate.member.phone" placeholder="请输入" :disabled="disabled"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="性别" >
                        <RadioGroup v-model="formValidate.member.sex">
                            <Radio label="1">男</Radio>
                            <Radio label="2">女</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="咨询日期" prop="mail">
                        <DatePicker type="date" placeholder="请选择" style="display:block" v-model="formValidate.member.consult_time"></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <Col span="7">
                        <FormItem label="所在区域">
                            <Select v-model="formValidate.member.province_id" placeholder="请选择" @on-change="changeProvince">
                                <Option v-for="item in province" :value="item.id" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem :label-width="0">
                            <Select v-model="formValidate.member.city_id" placeholder="请选择" @on-change="changeCity">
                                <Option v-for="item in city" :value="item.id" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem :label-width="0">
                            <Select v-model="formValidate.member.area_id" placeholder="请选择">
                                <Option v-for="item in area" :value="item.id" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="9">
                        <FormItem :label-width="0">
                            <Input v-model="formValidate.member.address" placeholder="请输入详细地址"></Input>
                        </FormItem>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem label="备注" prop="member.remark">
                        <Input v-model="formValidate.member.remark" type="textarea" :maxlength="200" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="民族">
                        <Input v-model="formValidate.member.nation" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="籍贯">
                        <Input v-model="formValidate.member.birth_place" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="学历">
                        <Input v-model="formValidate.member.education" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="身高">
                        <Input v-model="formValidate.member.height" type="number" placeholder="请输入">
                            <span slot="append">CM</span>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="体重">
                        <Input v-model="formValidate.member.weight" type="number" placeholder="请输入">
                            <span slot="append">KG</span>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="职业">
                        <!-- <Input v-model="formValidate.member.job" placeholder="请输入"></Input> -->
                        <Select v-model="formValidate.member.job"  placeholder="请选择职业" style="90%">
                            <Option v-for="item in baseData.industry" :value="item.id" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem label="家属信息">
                        <Button type="primary" @click="addFamily">添加</Button>
                    </FormItem>
                </Col>
            </Row>
            <Row v-for="(item,index) in formValidate.maternal_family" :key="item.id">
                <Col span="5" offset="3">
                    <FormItem :label-width="0">
                        <Input v-model="item.name" placeholder="请输入"></Input>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem :label-width="0">
                        <Select v-model="item.relation" placeholder="请选择">
                            <Option value="夫妻">夫妻</Option>
                            <Option value="女方家属">女方家属</Option>
                            <Option value="男方家属">男方家属</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem :label-width="0">
                        <Input v-model="item.phone" type="tel" :maxlength='maxlength'  placeholder="请输入" @on-blur="familyPhoneChange(item.phone)"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem :label-width="0">
                        <Button type="error" @click="delFamily(index)">删除</Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
export default {
    name:"customerInfo",
    props:['customerInfoDetailId','customerDrawer'],
    data(){
        return{
            disabled:false,
            baseData:baseData,
            maxlength:11,
            formValidate: {
                maternal_info:"",
                member:{
                    id:'',
                    name: '',
                    id_card: '',
                    birthday: '',
                    phone: '',
                    sex: '',
                    consult_time: '',
                    province_id:19,
                    city_id:289,
                    area_id:'',
                    address:'',
                    remark: '',
                    nation: '',
                    birth_place: '',
                    education: '',
                    height: '',
                    weight: '',
                    job: '',
                    child_birth:''
                },
                maternal_family:[]
            },
            ruleValidate: {
                'member.name': [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                'member.phone': [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                'member.consult_time': [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                'member.remark': [
                    { required: true, message: '请输入', trigger: 'blur' },
                ]
            },
            province:[],
            city:[],
            area:[],
            userDetail:{}
        }
    },
    created(){
        this.apiProvince()
    },
    mounted(){
        this.apiCity(this.formValidate.member.province_id)
        this.apiArea(this.formValidate.member.city_id)
    },
    methods: {
        familyPhoneChange(value){
            console.log(value)
            if(value == ''){
                this.$Message.warning('请输入家属手机号')
                return
            }
            if(!/^1[3456789]\d{9}$/.test(value)){
                this.$Message.warning('家属手机格式错误')
                return
            }
        },
        //获取客户基本信息
        apigetMemberDetail(id){
            serve.fetchGet(api.myMemberGetMemberDetail+"/"+id,{}).then(data => {
                console.log('获取客户基本信息',data)
                let detail = data.data
                this.userDetail = detail
                this.apiCity(detail.province_id,detail.city_id)
                this.apiArea(detail.city_id,detail.area_id)
                this.formValidate.member.id = detail.id
                this.formValidate.member.name = detail.name
                this.formValidate.member.id_card = detail.id_card
                this.formValidate.member.birthday = detail.birthday == '0' ? '' : detail.birthday
                this.formValidate.member.phone = detail.phone
                this.formValidate.member.sex = detail.sex+""
                this.formValidate.member.consult_time = detail.consult_time
                this.formValidate.member.province_id = detail.province_id
                this.formValidate.member.city_id = detail.city_id,
                this.formValidate.member.area_id = detail.area_id == '0' ? '' : detail.area_id,
                this.formValidate.member.address = detail.address
                this.formValidate.member.remark = detail.remark
                this.formValidate.member.nation = detail.nation
                this.formValidate.member.birth_place = detail.birth_place
                this.formValidate.member.education = detail.education
                this.formValidate.member.height = detail.height
                this.formValidate.member.weight = detail.weight
                this.formValidate.member.job = detail.job
                this.formValidate.maternal_family = detail.maternal_info_list.length == 0 ? [] : detail.maternal_info_list[0].maternal_family_list
                this.formValidate.maternal_info = detail.maternal_info_list.length == 0 ? '' : detail.maternal_info_list[0].maternal_info_id
                this.formValidate.member.child_birth = detail.maternal_info_list.length == 0 ? '' : detail.maternal_info_list[0].child_birth
            }).catch((error)=>{
                // this.$Message.error(error.response.data.message);
            })
        },
        //编辑客户信息
        apiEditMemberInfo(){
            let params ={
                member:{
                    id:this.formValidate.member.id,
                    name: this.formValidate.member.name,
                    id_card: this.formValidate.member.id_card,
                    birthday: util.dateFormat(this.formValidate.member.birthday),
                    phone: this.formValidate.member.phone,
                    sex: this.formValidate.member.sex,
                    consult_time: util.dateFormat(this.formValidate.member.consult_time),
                    province_id:this.formValidate.member.province_id,
                    city_id:this.formValidate.member.city_id,
                    area_id:this.formValidate.member.area_id,
                    address:this.formValidate.member.address,
                    remark: this.formValidate.member.remark,
                    nation: this.formValidate.member.nation,
                    birth_place: this.formValidate.member.birth_place,
                    education: this.formValidate.member.education,
                    height: this.formValidate.member.height,
                    weight: this.formValidate.member.weight,
                    job: this.formValidate.member.job,
                }
            }
            serve.fetchPut(api.myMemberEditMember,params).then(data => {
                console.log(data)
                this.$emit('watchUpdate',true)
                // this.$Message.success('保存成功');
                this.apiEditMemberFamily()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //请求修改家属信息
        apiEditMemberFamily(){
            let maternal_family = []
            if(this.formValidate.maternal_family.length){
                for(let item of this.formValidate.maternal_family){
                    maternal_family.push({
                        name:item.name,
                        relation:item.relation,
                        phone:item.phone
                    })
                }
            }
            let params ={
                member_id:this.formValidate.member.id,
                maternal_info_id:this.formValidate.maternal_info,
                maternal_family:maternal_family,
                child_birth:this.formValidate.member.child_birth,
            }
            serve.fetchPut(api.myMemberSaveMaternalOrFamily,params).then(data => {
                console.log(data)
                this.$Message.success('保存成功');
                this.apigetMemberDetail(this.customerInfoDetailId)
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //添加家属
        addFamily(){
            if(this.formValidate.maternal_family.length){
                for(let item of this.formValidate.maternal_family){
                    if(item.name =='' || item.relation=='' || item.phone == ''){
                        this.$Message.warning('请完善家属信息')
                        return
                    }
                    if(!/^1[3456789]\d{9}$/.test(item.phone)){
                        this.$Message.warning('家属手机格式错误')
                        return
                    }
                }
            }
            this.formValidate.maternal_family.push({
                name:"",
                relation:"",
                phone:""
            })
        }, 
        //删除家属信息
        delFamily(index){
            this.formValidate.maternal_family.splice(index,1)
        },
        //保存客户基本信息
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(this.formValidate.member.id_card){
                        let result = util.regIdCard(this.formValidate.member.id_card)
                        if(!result.check){
                            this.$Message.error(result.error)
                            return
                        }
                    }
                    if(this.formValidate.maternal_family.length){
                        for(let item of this.formValidate.maternal_family){
                            if(item.name == '' || item.relation== '' || item.phone.length == ''){
                                this.$Message.error('请完善家属信息');
                                return
                            }
                            if(!/^1[3456789]\d{9}$/.test(item.phone)){
                                this.$Message.error('家属手机格式错误')
                                return
                            }
                        }
                    }
                    let params = {
                       phone: this.formValidate.member.phone,
                       edit:1,
                       member_id:this.userDetail.id
                    }
                    serve.fetchGet(api.allMemberExternalPhoneExist,params).then(data => {
                        console.log(data)
                        // this.province = data.districts   
                        if(data[0].state){
                            this.$Modal.confirm({
                                title: '互换手机号',
                                content: '<p>手机号 <span style="color:red">'+data[0].msg.exist_phone+' （'+data[0].msg.exist_name+'）</span>已存在系统，是否将本客户的手机号<span style="color:red">'+data[0].msg.new_phone+'</span>与<span style="color:red">'+data[0].msg.exist_phone+'</span>进行互换</p>',
                                onOk: () => {
                                    this.apiEditMemberInfo()
                                }
                            });
                        }else{
                            this.apiEditMemberInfo()
                        }
                    }).catch((error)=>{
                        this.$Message.error(error.response.data.message);
                    })   
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        //省
        apiProvince(){
            serve.fetchGet(api.myMemberGetProvinceList,{}).then(data => {
                console.log(data)
                this.province = data.districts    
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //市
        apiCity(id,city_id){
            serve.fetchGet(api.myMemberGetCityList,{upid:id}).then(data => {
                console.log(data)
                this.city = data.districts
                if(city_id){
                    this.formValidate.member.city_id = city_id
                }
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //区
        apiArea(id,area_id){
            serve.fetchGet(api.myMemberGetCityList,{upid:id}).then(data => {
                console.log(data)
                this.area = data.districts 
                if(area_id){
                    this.formValidate.member.area_id = area_id
                } 
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //监听省
        changeProvince(id){
            this.formValidate.member.city_id = ''
            this.apiCity(id)
        },
        //监听市
        changeCity(id){
            this.apiArea(id)
            this.formValidate.member.area_id = ''
        },
        //身份证失去焦点验证
        idCardBlur(val){
            let result = util.regIdCard(val)
            if(!result.check && val != ''){
                this.$Message.error(result.error)
                return
            }
        },
        //是否可以编辑手机号的权限
        apiEditMemberPhone(i){
            serve.fetchGet(api.myMembergetEditMemberPhone,{}).then(data => {
                console.log("是否可以编辑手机号的权限",data)
                this.disabled = !data[0]
            }).catch((error)=>{
                this.disabled = true
                this.$Message.error(error.response.data.message);
            })
        },
    },
    watch:{
        customerDrawer(val){
            if(val){
                this.apigetMemberDetail(this.customerInfoDetailId)
                this.apiEditMemberPhone()
            }
        }
    }
}
</script>
<style scoped>
    .title{
        padding-top:10px;
        height: 32px;
        padding-bottom: 10px;
        margin-bottom:10px;
        border-bottom:1px solid #eee;
        display:flex;
        justify-content:space-between;
        align-items:center
    }
</style>


// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_customerInfo.vue